var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeDesktop3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 328 288",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M250.178 70.41C243.772-27.625 199.7-4.153 136.602 31.58c-29.951 20.036-66.293 45.396-125.344 166.82-73.813 151.781 270.673 81.797 307.081-.181 39.845-89.716-61.95-32.771-68.161-127.81"
})));
export default SvgShapeDesktop3;